<template>
	<div class="spinner" v-if="active"></div>
</template>

<script>
export default {
	name: "Spinner",
	props: ["active"]
};
</script>

<style scoped>
.spinner {
	position: absolute;
	top: 1rem;
	left: 46%;
	transform: translate(-50%, -50%);
	width: 40px;
	height: 40px;
	background-color: #999;
	border-radius: 100%;
	-webkit-animation: sk-scaleout 1s infinite ease-in-out;
	animation: sk-scaleout 1s infinite ease-in-out;
	z-index: 1;
}

@-webkit-keyframes sk-scaleout {
	0% {
		-webkit-transform: scale(0);
	}
	100% {
		-webkit-transform: scale(1);
		opacity: 0;
	}
}

@keyframes sk-scaleout {
	0% {
		-webkit-transform: scale(0);
		transform: scale(0);
	}
	100% {
		-webkit-transform: scale(1);
		transform: scale(1);
		opacity: 0;
	}
}
</style>
